// extracted by mini-css-extract-plugin
export var title = "index-modules--title--3M934";
export var languageLink = "index-modules--languageLink--VJ8T5";
export var partnerImageContainer = "index-modules--partnerImageContainer--8yajU";
export var partnerImage = "index-modules--partnerImage--1LDaD";
export var programTitle = "index-modules--programTitle--Tiytr";